



















import { Component, Vue, PropSync, Emit } from 'vue-property-decorator'
@Component
export default class PuzzleCover extends Vue {
  @PropSync('complete', { type: Boolean }) synceComplete!: boolean

  @Emit('play-change')
  private playToggle() {}

  /** 動畫結束後清除 style */
  private handleAnimationend({ target }: { target: HTMLElement }): void {
    setTimeout(() => target.removeAttribute('style'), 500)
  }
}
